import { DraggableAttributes, DraggableSyntheticListeners, useDraggable, useDroppable } from "@dnd-kit/core";

export const useDragAndDrop = <TData extends { id: string }>(data: TData): [(element: HTMLElement) => void, DraggableAttributes, DraggableSyntheticListeners] => {
    const { setNodeRef: draggableNodeRef, attributes, listeners } = useDraggable({ id: data.id, data: { ...data } });

    const { setNodeRef: droppableNodeRef } = useDroppable({ id: data.id, data: { ...data } });

    const setRefs = (element: HTMLElement) => {
        draggableNodeRef(element);
        droppableNodeRef(element);
    };

    return [setRefs, attributes, listeners];
};
